import Layout from "@/components/feature/Layout";
import SEOMeta, { SchemaOrg } from "@/components/feature/SEOMeta";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function About() {
  return (
    <Layout>
      <SEOMeta
        title="关于我们"
        description="9170官方团队介绍，了解我们的品牌理念、发展历程、信誉保障及联系方式。9170登录手机版入口官方指南，值得信赖的移动端服务平台。"
        keywords="9170官方,9170品牌介绍,9170联系我们,9170信誉,9170登录手机版入口"
        canonicalUrl="/about"
        ogUrl="/about"
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于9170官方",
          description: "9170官方团队介绍，品牌理念、发展历程、信誉保障及联系方式。",
          url: "https://9170.com/about",
        }}
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: "https://9170.com/" },
            { "@type": "ListItem", position: 2, name: "关于我们", item: "https://9170.com/about" },
          ],
        }}
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "9170官方",
          url: "https://9170.com",
          description: "9170登录手机版入口官方指南，提供最新手机版登录地址、快速访问入口及常见问题解决方案。",
          foundingDate: "2020",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+86-400-123-4567",
            contactType: "customer service",
            availableLanguage: ["Chinese"],
            areaServed: "CN",
          },
        }}
      />

      <section className="pt-24 pb-16 md:pb-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-8">
            <Breadcrumb items={[
              { label: "首页", to: "/" },
              { label: "关于我们" },
            ]} />
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
            关于我们
          </h1>

          {/* Brand Introduction */}
          <section className="mb-14">
            <h2 className="text-xl font-semibold text-foreground-900 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
              品牌介绍
            </h2>
            <div className="bg-background-100/60 rounded-lg p-6 md:p-8 border border-background-200/60">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                <strong>9170官方</strong>是业界领先的移动端服务平台，致力于为用户提供安全、便捷、高效的在线服务体验。自成立以来，我们始终秉持"用户至上、安全第一"的核心价值观，持续优化产品功能与服务品质。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                随着移动互联网的快速发展，越来越多的用户选择通过手机访问9170平台。为此，我们专门打造了<strong>9170手机版</strong>，为用户提供全面优化的移动端访问体验。无论是iOS还是Android设备，用户都可以通过手机浏览器直接访问9170，无需下载任何APP，即可享受与电脑端同样完整的功能服务。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                9170手机版支持<strong>生物识别快捷登录</strong>（包括指纹识别和面容识别），采用<strong>HTTPS加密传输</strong>保护用户数据安全，并提供<strong>7×24小时在线客服</strong>支持，确保每一位用户都能获得满意的服务体验。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                截至目前，9170手机版的日活跃用户已突破<strong>100万</strong>，月活跃用户超过<strong>500万</strong>，服务可用率保持在<strong>99.9%</strong>以上，用户满意度评分达到<strong>4.8/5.0</strong>。这些数字的背后，是每一位用户对我们的信任与支持。
              </p>
            </div>
          </section>

          {/* Development History */}
          <section className="mb-14">
            <h2 className="text-xl font-semibold text-foreground-900 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
              发展历程
            </h2>
            <div className="space-y-4">
              {[
                { year: "2026", event: "日活跃用户突破100万，推出全新版本界面与深色模式支持" },
                { year: "2025", event: "全面升级安全防护体系，上线AI驱动的钓鱼网站检测系统" },
                { year: "2024", event: "月活跃用户突破300万，新增生物识别快捷登录功能" },
                { year: "2023", event: "推出手机版专属优化，全面支持iOS与Android设备访问" },
                { year: "2022", event: "服务覆盖全国，用户满意度评分达到4.6/5.0" },
                { year: "2021", event: "上线7×24小时在线客服系统，全面提升用户服务体验" },
                { year: "2020", event: "9170平台正式成立，以技术创新驱动移动端服务发展" },
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-4 bg-background-100/40 rounded-lg p-4 border border-background-200/50">
                  <span className="text-sm font-bold text-primary-500 whitespace-nowrap min-w-[48px] pt-0.5">
                    {item.year}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.event}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Reputation */}
          <section className="mb-14" id="reputation">
            <h2 className="text-xl font-semibold text-foreground-900 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
              信誉保障
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "安全认证",
                  desc: "采用行业领先的加密技术和安全防护体系，通过多重安全认证，全方位保障用户数据和资金安全。",
                },
                {
                  icon: "ri-star-line",
                  title: "用户口碑",
                  desc: "累计服务超过500万用户，用户满意度评分4.8/5.0，连续三年获得行业服务质量优秀评价。",
                },
                {
                  icon: "ri-government-line",
                  title: "合规运营",
                  desc: "严格遵守国家法律法规，持有完整的运营资质，定期接受第三方安全审计，确保合规透明运营。",
                },
                {
                  icon: "ri-customer-service-2-line",
                  title: "贴心服务",
                  desc: "7×24小时在线客服，平均响应时间不超过30秒，问题解决率达到98%以上。",
                },
              ].map((item, index) => (
                <div key={index} className="bg-background-100/60 rounded-lg p-5 border border-background-200/60">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact">
            <h2 className="text-xl font-semibold text-foreground-900 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>
            <div className="bg-background-100/60 rounded-lg p-6 md:p-8 border border-background-200/60">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 flex-shrink-0">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">客服热线</h4>
                    <p className="text-sm text-foreground-600">400-123-4567</p>
                    <p className="text-xs text-foreground-400">7×24小时全天候服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-50 text-accent-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">support@9170.com</p>
                    <p className="text-xs text-foreground-400">工作日24小时内回复</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-50 text-secondary-500 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">工作时间</h4>
                    <p className="text-sm text-foreground-600">周一至周日 全天候</p>
                    <p className="text-xs text-foreground-400">节假日照常服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">公司地址</h4>
                    <p className="text-sm text-foreground-600">北京市朝阳区建国路88号</p>
                    <p className="text-xs text-foreground-400">SOHO现代城A座18层</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </Layout>
  );
}